import { ComponentType, ReactElement } from 'react';

import { SvgIconProps } from '@mui/material';

export const withStylesSvgIcon = (Component: ComponentType<SvgIconProps>) => {
  return function WithStylesSvgIcon({
    isFocused,
    ...props
  }: SvgIconProps & {
    isFocused: boolean;
  }): ReactElement {
    return (
      <Component
        sx={{
          fontSize: 18,
          color: ({ palette }) =>
            isFocused ? palette.text.primary : palette.gray200.main,
        }}
        {...props}
      />
    );
  };
};
